//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/partners' // @/configurations/content/partners-dark для темной темы

export default {
  logo: {
    image: require('@/assets/logo/logo-white.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'Mashroom logo'
  },
  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'Flow 2023 Конференция по системному и бизнес-анализу',
    description: [
      'На конференции соберутся специалисты по системному и бизнес-анализу, чтобы поговорить об архитектуре, требованиях, стандартах, документации и архитектуре данных.',
      'В программе будут выступления про проектирование взаимодействия сервисов, инструменты аналитика, моделирование бизнес-процессов и работу с требованиями. Словом, для всех, кто создает или работает со сложными системами.'
    ],
    date: '15-16.06.2023',
    time: '10:00-18:00'
  },
  activities: [
    {
      hash: 'MAclQpGI',
      id: 1357,
      tabName: 'Первый день'
    },
    {
      hash: 'PXBhAboi',
      id: 1106,
      tabName: 'Второй день' // название таба, при многозальном мероприятии
    }
  ],
  player: {
    title: 'Дни конференции' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Расписание' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/image.jpg'), // путь до изображения для блока с картинкой
    items: [
      'Мы проводим мероприятия для опытных специалистов. Сложные, технические, специализированные. Мы тщательно отбираем спикеров, которые помогут вам сориентироваться в индустрии: трендах, инструментах, подходах, глобальных обновлениях языков и платформ.',
      'Мы проводим мероприятия для опытных специалистов. Сложные, технические, специализированные. Мы тщательно отбираем спикеров, которые помогут вам сориентироваться в индустрии: трендах, инструментах, подходах, глобальных обновлениях языков и платформ.',
      'Мы проводим мероприятия для опытных специалистов. Сложные, технические, специализированные. Мы тщательно отбираем спикеров, которые помогут вам сориентироваться в индустрии: трендах, инструментах, подходах, глобальных обновлениях языков и платформ.',
      'Можно провести мероприятие в лесу, можно в поле, пустыне, на Крайнем Севере в условиях вечной мерзлоты. Везде с вами будет ваш верный проводник и гуру информационный архитектуры Василий Вадимович Хлопотунчик'
    ]
  },
  info: {
    title: 'О площадке', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      'В первую очередь, мы рекомендуем использовать общественный транспорт для очного участия. Площадка мероприятия находится в пешей доступности от станций метро "Добрынинская" и "Октябрьская"',
    'Мы стремимся сделать ваше пребывание на нашей конференции максимально комфортным и удобным. Мы предоставляем места для парковки, беспроводной интернет, кондиционирование воздуха и другие удобства.'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Mashroom.',
    phone: '+7 926 260 53 22'
  }
}
